import { Injectable, inject } from "@angular/core";
import { AppSettings } from "app/app.settings";
import { Observable, Subject } from "rxjs";
import * as signalR from "@microsoft/signalr";

@Injectable({
   providedIn: "root"
})
export class CustomerSignalRService {
   private appSettings = inject(AppSettings);

   private readonly baseUri: string;
   private readonly endpoint: string;

   private hubConnection: signalR.HubConnection;

   private messageSubject: Subject<any> = new Subject<any>();

   constructor() {
      this.baseUri = `${this.appSettings.baseCoreApiUrl}`;
      this.endpoint = `signalr/customer`; // URL of the SignalR hub

      this.hubConnection = new signalR.HubConnectionBuilder()
         .withUrl(`${this.baseUri}/${this.endpoint}`, {
            accessTokenFactory: () => "", // Provide token if needed
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
         })
         .withAutomaticReconnect()
         .build();
   }

   private ensureConnection(): void {
      if (this.hubConnection.state === signalR.HubConnectionState.Connected) {
         return;
      }

      this.hubConnection.stop();
      this.hubConnection
         .start()
         .then(_ => console.log("SignalR Connection started"))
         .catch(err => {
            console.log("Error establishing SignalR connection: " + err);
            this.hubConnection.stop();
         });
   }

   public stop(): void {
      // Cleanup message object
      this.messageSubject.next(undefined);
      this.messageSubject.complete();

      // Stop the connection
      if (this.hubConnection) {
         this.hubConnection.stop();
      }
   }

   public on(event: string): Observable<any> {
      this.ensureConnection();

      this.hubConnection.on(event, (data: any) =>
         this.messageSubject.next(data)
      );
      return this.messageSubject;
   }
}
